import { ComboDataDTO, defaultComboDataDTO } from '../ComboDataDTO'

export interface UsersProfileOptionDTO extends ComboDataDTO {
  tagCodes: string[]
}

export interface UsersHealthEntityOptionDTO extends ComboDataDTO {}

export interface UsersLocationContextDTO {
  country: ComboDataDTO | null
  province: ComboDataDTO | null
  city: ComboDataDTO | null
}

export interface UsersListItemDTO {
  userId: number
  medereEntityId: number | null
  username: string
  firstname: string
  lastname: string
  document: string
  email: string
  profileId: number | null
  profile: string
  blocked: boolean
  externalId: string
  pictureRoute: string
  languageId: number | null
  languageName: string
}

export interface UsersFormDTO {
  userId: number
  medereEntityId: number | null
  username: string
  firstname: string
  lastname: string
  email: string
  profile: ComboDataDTO | null
  language: ComboDataDTO | null
  blocked: boolean
  externalId: string
  documentType: ComboDataDTO | null
  document: string
  gender: string
  birthDate: Date | null
  consentSigningDate: Date | null
  country: ComboDataDTO | null
  province: ComboDataDTO | null
  city: ComboDataDTO | null
  address: string
  mobilePhone: string
  healthEntities: UsersHealthEntityOptionDTO[]
}

export interface UsersSaveDTO {
  userId: number
  medereEntityId: number | null
  username: string
  firstname: string
  lastname: string
  email: string
  profileId: number | null
  languageId: number | null
  blocked: boolean
  externalId: string
  documentTypeId: number | null
  document: string
  gender: string
  birthDate: string | null
  cityId: number | null
  address: string
  mobilePhone: string
  password: string
  confirmPassword: string
  healthEntityIds: number[]
}

export interface UsersConversionCandidateDTO {
  medereEntityId: number
  userId: number | null
  hasUser: boolean
  recordType: string
  onlyPatient: boolean
  username: string
  firstname: string
  lastname: string
  document: string
  documentType: string
  email: string
  phoneNumber: string
  mobilePhone: string
  gender: string
  birthDate: Date | null
  address: string
  country: ComboDataDTO | null
  province: ComboDataDTO | null
  city: ComboDataDTO | null
  active: boolean
}

export interface UsersListQueryParams {
  scope?: 'admin' | 'auditor'
  profileFilter?: string[]
  blockedFilter?: boolean[]
  multiSortMeta?: unknown
  filterDTO?: unknown
  cardFilterDTO?: unknown
}

export const defaultUsersLocationContextDTO: UsersLocationContextDTO = {
  country: defaultComboDataDTO,
  province: defaultComboDataDTO,
  city: defaultComboDataDTO,
}

export const defaultUsersFormDTO: UsersFormDTO = {
  userId: -1,
  medereEntityId: null,
  username: '',
  firstname: '',
  lastname: '',
  email: '',
  profile: defaultComboDataDTO,
  language: defaultComboDataDTO,
  blocked: false,
  externalId: '',
  documentType: defaultComboDataDTO,
  document: '',
  gender: '',
  birthDate: null,
  consentSigningDate: null,
  country: defaultComboDataDTO,
  province: defaultComboDataDTO,
  city: defaultComboDataDTO,
  address: '',
  mobilePhone: '',
  healthEntities: [],
}

export const defaultUsersSaveDTO: UsersSaveDTO = {
  userId: -1,
  medereEntityId: null,
  username: '',
  firstname: '',
  lastname: '',
  email: '',
  profileId: null,
  languageId: null,
  blocked: false,
  externalId: '',
  documentTypeId: null,
  document: '',
  gender: '',
  birthDate: null,
  cityId: null,
  address: '',
  mobilePhone: '',
  password: '',
  confirmPassword: '',
  healthEntityIds: [],
}
